export default "__VITE_ASSET__66bc7cfa__"